<template>
  <div id="ExemptionApply">
    <ots-main-title :mainTopBtn="mainTopBtn"></ots-main-title>
    <ots-table-group-new
      ref="ots-table"
      :selectList="selectList"
      :requestForm="requestForm"
      @search="search"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :batchOperBtn="batchOperBtn"
      :pagination="pagination"
      @changeNum="changeNum"
      @changePage="changePage"
      :isDisabledMultiple="isDisabledMultiple"
      @handleSelectionChange="bachOper"
      :tableOption="tableOption"
    ></ots-table-group-new>

    <!-- 材料上传 -->
    <ots-custom-dialog :dialog.sync="exportExperDialog" title="上传免考材料" width="50%">
      <template v-slot:content>
        <p v-if="planInfo.scorePublish == 0">免考材料：（支持 JPG, JPEG, GIF, PNG, PDF）</p>
        <ots-upload-file v-model="importForm.file" ref="upLoad" :httpRequest="handleFormData" style="margin-top: 8px;" v-if="planInfo.scorePublish == 0"/>
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-remove="handleRemove"
          :before-upload="beforeAvatarUpload"
          multiple
          :limit="3"
          :file-list="fileList"
          list-type="picture"
          >
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.materialType == 'pdf'? defaultUrl: file.url" alt="" @click="openImg(file, file.url)">
              <span class="el-upload-list__item-actions">
                <a class="el-upload-list__item-name"><i class="el-icon-document"></i></a>
                <span class="el-upload-list__item-preview">
                  {{ file.name }}
                </span>
              </span>
              <label class="el-upload-list__item-status-label">
                <i class="el-icon-upload-success el-icon-check"></i>
              </label>
              <i class="el-icon-close" @click="handleRemove(file, fileList)" v-if="planInfo.scorePublish == 0"></i>
            </div>
        </el-upload>
      </template>
      <template v-slot:footer>
        <el-button round @click="exportExperDialog = false">关闭窗口</el-button>
      </template>
    </ots-custom-dialog>
    <!-- 申请免考 -->
    <ots-custom-dialog :dialog.sync="exemptDialog" :title="isShow? '查看': '申请免考'" width="60%">
      <template v-slot:content>
        <div class="submitTitle">
          <p>考试批次：{{exemptInfo.planName}}</p>
          <p>教学点：{{exemptInfo.stationName}}</p>
          <p>考点：{{exemptInfo.placeName}}</p>
        </div>
        <div class="submitTitle_2">
          <p>考生姓名：{{exemptInfo.realName}}</p>
          <p>准考证号：{{exemptInfo.entranceCode}}</p>
          <p>证件号：{{exemptInfo.cardNo}}</p>
        </div>
        <div class="submitTitle_3">
          <p>免考课程：{{exemptInfo.subCourseCodeName}}</p>
          <!-- <p v-if="exemptInfo.subCourseCodeCount != '1'">单科：{{exemptInfo.subCourseCodeName}}</p> -->
          <p v-if="isShow">免考原因：{{exemptInfo.reasonName}}</p>
          <div v-else>
            <span>免考原因：</span>
              <el-select v-model="reasonId" placeholder="请选择">
                <el-option
                  v-for="item in reasonList"
                  :key="item.reasonId"
                  :label="item.reasonName"
                  :value="item.reasonId">
                </el-option>
              </el-select>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="exemptDialog = false">{{isShow? "关闭窗口": "取消"}}</el-button>
        <el-button round type="primary" plain @click="exemptSet" v-show="!isShow">确定免考</el-button>
      </template>
    </ots-custom-dialog>
    <!-- 导入免考名单 -->
    <ots-custom-dialog :dialog.sync="exportRosterDialog" title="导入免考名单" width="40%">
      <template v-slot:content>
            <el-form ref="exportRosterForm" :model="exportRosterForm">
              <el-form-item label="选择批次" class="mb20">
                <el-select v-model="exportRosterForm.planId" clearable placeholder="请选择">
                  <el-option v-for="item in examBatchList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="1.模板下载">
                <span style="color: #006aff" @click="downFile()" class="cp">
                  <i class="el-icon-download"></i>
                  下载免考导入模板
                </span>
              </el-form-item>
              <el-form-item v-model="exportRosterForm.file" label="2.导入文件">
                <ots-upload-file :httpRequest="handleFormDataRoster" fileType="xlsx" />
              </el-form-item>
            </el-form>
      </template>
      <template v-slot:footer>
        <el-button round @click="exportRosterDialog = false">取消</el-button>
        <el-button round @click="exportRosterSet">导入</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getCurrentSelectPlace } from "@/http/modules/examSet/planClass";
import { getPlaceList } from "@/http/modules/baseSet/examSite";

import { importReasonInfoAPI, downloadReasonInfoAPI, exportReasonInfoAPI, getReasonCourseListAPI, getReasonApplyListAPI, uploadMaterialAPI, getReasonMaterialListAPI, getReasonListAPI, saveReasonInfoAPI, deleteReasonMaterialListAPI, deleteReasonInfoAPI, synchronousExemptInfoAPI } from "@/http/modules/examSet/score";
export default {
  data() {
    return {
      importForm: {
        file: "",
        reasonInfoId: "",
      },
      fileList: [],
      mainTopBtn: [
        {
          title: "同步免考名单",
          plain: true,
          fn: this.syncExampt
        },
        {
          title: "导出",
          plain: true,
          fn: this.export,
        },
      ],
      selectList: [
        {
          title: "考试批次",
          isSearch: true,
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "关键词",
          type: "input",
          requestKey: "keyWord",
          placeholder: "姓名/证件号/准考证号",
        },
        {
          title: "教学点",
          type: "select",
          isSearch: true,
          requestKey: "stationId",
          label: "stationName",
          value: "stationId",
          data: [],
        },
        {
          title: '考点名称',
          type: 'select',
          requestKey: 'placeId',
          label: 'placeName',
          value: 'placeId',
          data: [],
        },
        {
          title: '课程名称',
          type: 'select',
          requestKey: 'subCourseCode',
          label: 'subCourseCodeName',
          value: 'subCourseCode',
          data: [],
        },
        {
          title: "免考申请状态",
          type: "select",
          requestKey: "applyFlag",
          label: "name",
          value: "id",
          data: [
            { id: '', name: "全部"},
            { id: 1, name: "已申请" },
            { id: 0, name: "未申请" },
          ]
        }
      ],
      requestForm: {
        planId: "",
        stationId: "",
        placeId: "",
        subCourseCode: "",
        keyWord: "",
        applyFlag: "",
        page: 1,
        size: 10,
      },
      pagination: {
        total: 0,
      },
      tableOption: {
        multiple: true,
      },
      tableHeader: [
        {
          title: "教学点",
          prop: "stationName",
        },
        {
          title: "考点",
          prop: "placeName",
        },
        {
          title: "姓名",
          prop: "realName"
        },
        {
          title: "准考证号",
          prop: "entranceCode",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "课程名称",
          prop: "subCourseCodeName",
        },
        {
          title: "免考原因",
          prop: "reasonName",
        },
        {
          title: "免考申请状态",
          prop: "reasonStatusName"
        },
        {
          title: "免考申请证明材料",
          type: "button",
          formatter: this.buttonSet,
          click: this.exportExper,
          disableFn: this.exportDisabled

        },
        {
          title: "操作",
          type: "buttons",
          width: "180px",
          btnList: [
            {
              title: "申请免考",
              click: this.exempt,
              formatter: this.exemptFormat

            },
            {
              title: "查看",
              click: this.show,
              formatter: function(scope) {
                return scope.row.reasonStatusName != "已申请";
              }
            },
            {
              title: "删除",
              click: this.delete,
              formatter: this.isShowDeleteBtn,
            },
          ]
        },

      ],
      tableData: [],
      batchOperBtn: [
        {
          title: "导入免考名单",
          icon: "iconfont icon-daoru",
          click: this.exportRoster,
        },
        {
          title: "删除免考名单",
          icon: "iconfont icon-shanchu",
          click: this.deleteRoster
        },
      ],
      planInfo: {},
      exportExperDialog: false,

      // 申请免考
      exemptDialog: false,
      exemptInfo: {},
      exemptForm: {
        planId: "",
        studentCourseId: "", 
        recordSubCourseId: "", 
        subCourseCodeCount: "", 
        answerScore: "",
        reasonId: "",
      },
      reasonList: [],
      reasonId: "",

      // 查看免考
      isShow: false,
      defaultUrl: require("@/assets/img/PDFIcon.png"),

      // 导入/删除免考名单
      examBatchList: [],
      exportRosterDialog: false,
      exportRosterForm: {
        planId: "",
        file: "",
      },
      selectIds: []
    }
  },
  watch: {
    "requestForm.planId": async function(planId) {
      await this.getPlanInfo(planId);
      this.getCourseList(planId);
      this.getStationList(planId);
      this.getPlaceList();
      await this.search();
    },

    "requestForm.stationId": async function(stationId) {
      this.getPlaceList();
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    // 同步免考名单
    async syncExampt() {
      const { code, data } = await synchronousExemptInfoAPI({planId: this.requestForm.planId});
      if (code) {
        this.$message.success(data);
      }
    },


    exportDisabled(scope) {
      let flag = false;
      let {scorePublish} = this.planInfo;
      if (scope.row.reasonStatusName != "已申请") {
        flag = false;
      } else {
        if (scorePublish == 0) {
          flag = false;
        } else {
          flag = true
        }
      }
      if (flag && this.planInfo.state != 1) {
        return false;
      } else if (this.planInfo.state == 1) {
        return scope.row.reasonStatusName != "已申请";
      } else {
        return true;
      }
    },

    exemptFormat(scope) {
      if (this.planInfo.state == 1) {
        return scope.row.reasonStatusName == "已申请";
      } else {
        return true;
      }
    },

    /******************************************
     * @param { 按钮权限 }
     ******************************************/
    isShowDeleteBtn(scope) {
      if (this.planInfo.state == 1) {
        if (this.planInfo.scorePublish == 0 && scope.row.reasonStatusName == "已申请") {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    buttonSet(scope) {
      let {scorePublish} = this.planInfo;
      if (scope.row.reasonStatusName != "已申请") {
        return " - "
      } else {
        if (scorePublish == 0) {
          return "上传";
        } else {
          return "查看"
        }
      }
    },

    /******************************************
     * @param { 基础数据 }
     ******************************************/
    async initData() {
      const { data: planList } = await getSelectPlanFn({ needAudit: 16 });
      this.selectList[0].data = planList;
      const { data: planList2 } = await getSelectPlanFn({ needAudit: 15 });
      this.examBatchList = planList2;
      this.exportRosterForm.planId = planList2[0].id;
      this.requestForm.planId = planList[0].id;
      const {data: reasonList} = await getReasonListAPI();
      this.reasonList = [];
      reasonList.map(e => {
        if (e.stopFlag == 0) {
          this.reasonList.push(e);
        }
      })
    },

    async getStationList(planId) {
      this.requestForm.stationId = "";
      const {data: stationList} = await this.$api.system.getStationsForPlan({planId});
      this.selectList[2].data = [...stationList];
    },


    async getPlaceList() {
      let params = {
        planId: this.requestForm.planId,
        stationId: this.requestForm.stationId,
      }
      const { data: placeData } = await getPlaceList(params);
      if (!placeData) {
        this.selectList[3].data = [];
        this.requestForm.placeId = '';
        return;
      }
      this.selectList[3].data = [...placeData];
      this.requestForm.placeId = "";
    },

    
    async getCourseList(value) {
      this.requestForm.subCourseCode = "";
      const { data } = await getReasonCourseListAPI({ planId: value });
      let courseIdList = [{ subCourseCode: "", subCourseCodeName: "全部" }, ...data];
      this.$set(this.selectList[4], "data", courseIdList);
    },
    async getPlanInfo(planId) {
      const {data: planInfo} = await this.$api.applyManage.getCurrentPlan({ planId });
      this.planInfo = planInfo;
    },

    /******************************************
     * @param { 申请免考 }
     ******************************************/
    exempt(row) {
      this.exemptInfo = row;
      this.isShow = false;
      this.exemptDialog = true;
    },
    async exemptSet() {
      if (!this.reasonId) {
        this.$message.error("请选择免考原因！");
        return;
      }
      let { planId, studentCourseId, recordSubCourseId, subCourseCodeCount, answerScore } = this.exemptInfo;
      let reasonId = this.reasonId;
      let params = {
        planId,
        studentCourseId,
        recordSubCourseId,
        subCourseCodeCount,
        answerScore,
        reasonId
      }
      const { code } = await saveReasonInfoAPI(params);
      if (code) {
        this.$message.success("免考申请成功！");
      }
      this.getTableData();
      this.exemptDialog = false;
    },

    /******************************************
     * @param { 查看 }
     ******************************************/
    show(row) {
      this.exemptInfo = row;
      this.isShow = true;
      this.exemptDialog = true;
    },

    /******************************************
     * @param { 免考申请证明材料 }
     ******************************************/
    async exportExper(row) {
      this.importForm.reasonInfoId = row.reasonInfoId;
      const { data: fileList } = await getReasonMaterialListAPI({reasonInfoId: row.reasonInfoId})
      this.fileList = fileList;
      this.exportExperDialog = true;
    },
    async handleFormData(val) {
      this.importForm.file = val.file;
      const fd = new FormData();
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item]);
      }
      const { code } = await uploadMaterialAPI(fd);
      if (code) {
        const { data: fileList } = await getReasonMaterialListAPI({reasonInfoId: this.importForm.reasonInfoId})
        this.fileList = fileList;
      }
    },
    async handleRemove(file, fileList) {
      let materialId = file.materialId;
      const { code } = await deleteReasonMaterialListAPI({materialId});
      if (code) {
        const { data: fileList } = await getReasonMaterialListAPI({reasonInfoId: this.importForm.reasonInfoId})
        this.fileList = fileList;
      }
    },
    beforeAvatarUpload(fileData) {
      let ImgRules = ["jpg", "jpeg", "png", "pdf", "gif"]
      let type = fileData.name.substring(fileData.name.lastIndexOf(".") + 1);
      const isJPG = ImgRules.indexOf(type) !== -1;
      if(!isJPG) {
        this.$message.error(`申请材料只能是 "PDF", "JPG", "JPEG", "PNG", "GIF" 格式!`);
      }
      return isJPG
    },
    openImg(file, url) {
      window.open(url);
    },

    // beforeAvatarUpload(fileData) {
    //   let ImgRules = ["jpg", "jpeg", "png", "pdf", "gif"]
    //   let type = fileData.name.substring(fileData.name.lastIndexOf(".") + 1);
    //   const isJPG = ImgRules.indexOf(type) !== -1;
    //   if(!isJPG) {
    //     this.$message.error(`申请材料只能是 "PDF", "JPG", "JPEG", "PNG", "GIF" 格式!`);
    //   }
    //   return isJPG
    // },
    // openImg(file, url) {
    //   window.open(url);
    // },



    /******************************************
     * @param { 删除 }
     ******************************************/
    delete(row) {
      let params = {
        reasonInfoIds: row.reasonInfoId,
        planId: row.planId
      }
      let message = `删除后考生 ${row.subCourseCodeName} 成绩将恢复为免考前的成绩。`
      this.$confirm(message, "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteReasonInfoAPI(params).then(({ code })=>{
          if (code) {
            this.$message.success("删除成功！");
            this.getTableData();
          }
        })
      })
    },



    /******************************************
     * @param { 导出 }
     ******************************************/
    async export() {
      let params = { ...this.requestForm }
      const { data, code } = await exportReasonInfoAPI(params);
      if (code) {
        this.$message.success("导出成功！");
        window.open(data);
      }
    },

    /******************************************
     * @param { 导入/删除 免考名单 }
     ******************************************/
    exportRoster() {
      // this.exportRosterForm.planId = this.requestForm.planId;
      this.exportRosterDialog = true;
    },
    async exportRosterSet() {
      const fd = new FormData();
      for (let item in this.exportRosterForm) {
        fd.append(item, this.exportRosterForm[item]);
      }
      const { code, data } = await importReasonInfoAPI(fd);
      if (code) {
        this.exportRosterDialog = false;
        const failNum = data.errorCount ? parseInt(data.errorCount) : 0;
        const totalNum = parseInt(data.allCount);
        const successNum = totalNum - failNum;
        let message = `导入完成，成功导入${successNum}，失败人员数${failNum}`;
        this.$confirm(message, "导入结果", {
          confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
          cancelButtonText: "取消",
          type: failNum > 0 ? "warning" : "success",
        }).then(() => {
          if (failNum > 0) {
            window.location.href = data.address;
          }
        });
        this.getTableData();
      }
    },
    downFile() {
      downloadReasonInfoAPI({planId: this.exportRosterForm.planId}).then(res=>{
        window.location.href = res.data;
      })
    },
    handleFormDataRoster(val) {
      this.exportRosterForm.file = val.file;
    },
    deleteRoster() {
      if(this.selectIds.length == 0) {
        this.$message.warning("请勾选相关信息。");
        return;
      }
      let params = {
        planId: this.requestForm.planId,
        reasonInfoIds: this.selectIds.join(",")
      }
      this.$confirm("删除后考生成绩将恢复为免考前的成绩。", "删除免考名单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteReasonInfoAPI(params).then(({ code })=>{
          if (code) {
            this.$message.success("删除成功！");
            this.getTableData();
          }
        })
      })
    },
    bachOper(val) {
      let idList = [];
      val.forEach((item) => {
        idList.push(item.reasonInfoId);
      });
      this.selectIds = idList;
    },

    isDisabledMultiple(row) {
      let { reasonInfoId } = row;

      if (this.planInfo.state != 1) {
        return false;
      } else {
        if (reasonInfoId) {
          return true;
        }
        return false;
      }
    },

    /******************************************
     * @param { 表格数据 }
     ******************************************/
    async search() {
      this.requestForm.page = 1;
      await this.getTableData();
    },

    async getTableData() {
      let params = { ...this.requestForm };
      // params.planId = "5fff64e8-ad1a-47c2-9bfe-8c3528c68dc8"
      const { code, data } = await getReasonApplyListAPI(params);
      if (code) {
        this.tableData = data.records;
        this.pagination.total = data.total;
      }
    },

    

    // 每页数量
    changeNum(num) {
      this.requestForm.size = num;
      this.getTableData();
    },
    // 页码
    changePage(p) {
      this.requestForm.page = p;
      this.getTableData();
    },
  }
}
</script>

<style scoped lang="less">
.submitTitle {
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
  border-bottom: 1px solid #ccc;
}
.submitTitle_2 {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
.submitTitle,.submitTitle_2 {
  &>p{
    width: 32%;
  }
}
.submitTitle_3 {
  margin: 48px auto 0;
  width: 360px;
  &>p {
    margin-bottom: 16px;
  }
}
</style>